// The onboarding cards live deep inside the message feed, well below the layout that owns
// the invite modal and the widgets pane. Same pattern as accountOptionsModal: the card
// dispatches, MainLayout listens.

export const ONBOARDING_INVITE_PEOPLE_EVENT = 'output:internal:onboarding-invite-people';
export const ONBOARDING_OPEN_WIDGETS_EVENT = 'output:internal:onboarding-open-widgets';

// `user` (optional) arrives preselected in the modal, so tapping a suggested face lands
// on the invite sheet with that person already chipped rather than an empty picker.
/** @param {{ id: string } | null} [user] */
export function openInvitePeopleFromOnboarding(user = null) {
  window.dispatchEvent(new CustomEvent(ONBOARDING_INVITE_PEOPLE_EVENT, { detail: { user } }));
}

export function openWidgetsFromOnboarding() {
  window.dispatchEvent(new CustomEvent(ONBOARDING_OPEN_WIDGETS_EVENT, { detail: {} }));
}
